import React, { useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNewTranslation, useDeleteTeamRedirectPath } from 'hooks'
import { TeamState, deleteTeam } from 'state/teams'
import { logout, selectTeamList, selectIsInternalUser, TeamState as TeamListState } from 'state/profile'
import { setTeamFilter } from 'state/filter'
import Modal from 'particles/Modal'
import Text from 'particles/Text'
interface DeleteTeamModalProps {
    onClose: () => void
    team?: TeamState
    onConfirm: () => void
}
const DeleteTeam: React.FC<DeleteTeamModalProps> = ({ onClose, team }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const teamList = useSelector(selectTeamList)
    const isInternalUser = useSelector(selectIsInternalUser)
    const deleteTeamDirectPath = useDeleteTeamRedirectPath(team?.uuid)

    const isDeleteTeamTheLastTeam = useMemo(() => {
        return team && teamList && teamList.length === 1 && team?.uuid === teamList[0].id
    }, [teamList, team])

    const onSuccessCallBack = () => {
        const newTeamList = teamList.filter((profileTeam: TeamListState) => {
            return profileTeam.id !== team?.uuid
        })
        if (!isInternalUser && newTeamList.length > 0) {
            dispatch(setTeamFilter(newTeamList[0].id))
        } else {
            return
        }
    }

    const onDeleteTeam = (team: TeamState | undefined) => {
        team &&
            dispatch(
                deleteTeam({
                    teamUuid: team.uuid,
                    directPath: deleteTeamDirectPath,
                    onSuccessCallBack: onSuccessCallBack,
                }),
            )
        onClose()
    }

    const handleCloseModal = (e: any): void => {
        if (e.target.id === 'pop-up-delete-modal') {
            onClose()
        }
    }

    useEffect(() => {
        window.addEventListener('click', handleCloseModal)
        return (): void => window.removeEventListener('click', handleCloseModal)
    }, [])
    return (
        <>
            {team ? (
                <Modal
                    title={t('modalWindow.confirmationMessage.deleteTeamWindowTitle', {
                        teamName: team?.name,
                    })}
                    secondaryButtonProps={{
                        label: t('button.noCancel'),
                    }}
                    primaryButtonProps={{
                        label: t('button.yesDelete'),
                    }}
                    size="m"
                    hasIcon={false}
                    onConfirm={() => {
                        onDeleteTeam(team)
                        if (isDeleteTeamTheLastTeam) {
                            dispatch(logout)
                        }
                    }}
                    onClose={onClose}
                >
                    <>
                        <Text scale="bodyM400">{t('modalWindow.confirmationMessage.deleteTeamSubtitle')}</Text>
                        <Text scale="bodyM400">
                            {t('modalWindow.confirmationMessage.deleteTeamMembersCantAccessBulletPointSubtitle')}
                        </Text>
                        <Text scale="bodyM400">
                            {t('modalWindow.confirmationMessage.deleteTeamMembersBrandsStillExistBulletPointSubtitle')}
                        </Text>
                        <Text scale="bodyM400">{t('modalWindow.confirmationMessage.deleteTeamCantUndoSubtitle')}</Text>
                    </>
                </Modal>
            ) : null}
        </>
    )
}

export default DeleteTeam
